<template>
  <!-- start: menu-item -->
  <!-- 如果没有子级路由，设置其是一个导航栏目 -->
  <el-menu-item
    v-if="!renderAsSubmenu"
    :index="renderingRoute.path"
    @click="nodeClick(renderingRoute)"
  >
    <i v-if="renderingRoute.meta && renderingRoute.meta.icon" :class="renderingRoute.meta.icon"></i>
    <span slot="title">{{ renderingRoute.meta.title || '未命名' }}</span>
  </el-menu-item>
  <!-- end: 如果没有子级路由 -->

  <!-- start: submenu -->
  <!-- 如果有子级路由，则设置其为一个菜单 -->
  <el-submenu v-else popper-class="submenu-popper" :index="renderingRoute.path">
    <!-- title -->
    <template slot="title">
      <i
        v-if="renderingRoute.meta && renderingRoute.meta.icon"
        :class="renderingRoute.meta.icon"
      ></i>
      <span>{{ renderingRoute.meta.title || '未命名' }}</span>
    </template>

    <!-- items -->
    <template v-for="child in renderingRoute.children">
      <navigator-item
        v-if="child.children && child.children.length > 0"
        :key="child.name"
        :route="child"
        @node-click="parentClick(child)"
      >
      </navigator-item>

      <el-menu-item
        v-else-if="!child.hidden && (!child.children || child.children.length === 0)"
        :key="child.name"
        :index="child.path"
        @click="nodeClick(child)"
      >
        <span slot="title">{{ child.meta.title || '未命名' }}</span>
      </el-menu-item>
    </template>
  </el-submenu>
  <!-- end: submenu -->
</template>

<script>
export default {
  name: 'NavigatorItem',

  props: {
    route: {
      type: Object
    }
  },

  computed: {
    renderAsSubmenu() {
      return this.renderingRoute.meta.isRenderAsSubmenu;
    },
    /**
     * 计算当前渲染的路由
     */
    renderingRoute() {
      return this.route;
    }
  },

  methods: {
    nodeClick(route) {
      this.$emit('node-click', route);
    },
    parentClick(route) {
      this.$emit('node-click', route);
    }
  }
};
</script>

<style lang="scss">
.submenu-popper {
  .el-menu.el-menu--popup {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
    background-color: #fff !important;
  }

  .el-menu-item {
    color: #1b1b1b !important;
    background-color: #fff !important;

    &:not(.is-disabled):hover {
      background-color: #f2f4f8 !important;
      color: $g-color-primary !important;
    }
  }
}
</style>
